import { TableTemplate } from "components/templates/default/table/TableTemplate";
import { GetOperationLogResponseResult as OperationLog } from "api/interfaces/operationlogInterface.interface";
import styled from "styled-components";
import { SearchParams } from "./OperationContainer";
import { SearchFilter } from "./SearchFilter";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import { CommonTable } from "components/atoms/table/AntdTable";
import { TableColumnsType } from "antd";
import Status, { StatusType } from "components/blocks/status/Status";

type Props = {
  data: OperationLog[];
  accountInfo: ProfileAccountInfo;
  onClickSearch: () => void;
  onSearchParamChange: (name: string, value: any) => void;
  searchParams: SearchParams;
  paginationInfo: BasePagination;
  setPaginationInfo: React.Dispatch<React.SetStateAction<BasePagination>>;
  onChangePage: (page: number) => void;
  status: StatusType;
  columns: TableColumnsType<OperationLog>;
};

export function OperationPresenter(props: Props): JSX.Element {
  return (
    <>
      <TableTemplate
        noSearch={true}
        titleComponent="Logging"
        centerChildren={<Status status={props.status} />}
      >
        <SearchFilter
          onClickSearch={props.onClickSearch}
          onSearchParamChange={props.onSearchParamChange}
          searchParams={props.searchParams}
        />
        <Container>
          <CommonTable
            columns={props.columns}
            dataSource={props.data}
            queryInfo={props.paginationInfo}
            onChangePage={props.onChangePage}
            loading={false}
          />
        </Container>
      </TableTemplate>
    </>
  );
}

const Container = styled.div`
  & .table-template .subheader {
    display: none;
  }
`;
